// extracted by mini-css-extract-plugin
export var container = "card-module--container--bylKC";
export var deadBill = "card-module--dead-bill--IG3m8";
export var deadBillIcon = "card-module--dead-bill-icon--Js8-V";
export var description = "card-module--description--5KSlg";
export var headerContainer = "card-module--header-container--VwuO+";
export var itemContainer = "card-module--item-container---srwv";
export var itemTitle = "card-module--item-title--JVVNI";
export var kicker = "card-module--kicker--nahKx";
export var minimalContainer = "card-module--minimal-container--d3GVb";
export var reporterCommentInline = "card-module--reporter-comment-inline--HfD9k";
export var sponsor = "card-module--sponsor--T3YTY";
export var title = "card-module--title--f5v9r";
export var tooltip = "card-module--tooltip--k6eiA";
export var tooltipBody = "card-module--tooltip-body--iqqFI";
export var tooltipButton = "card-module--tooltip-button--Dr7mV";
export var tooltipContainer = "card-module--tooltip-container--lNNw6";
export var tooltipHeading = "card-module--tooltip-heading--Cmqui";